import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class KeFuEwm extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.sc_wem}>
                <img src={content.image} />
            </div>
        );
    }
}

export default errorBoundary(KeFuEwm);
